import { render, staticRenderFns } from "./BgMusic.vue?vue&type=template&id=0606d6ec&scoped=true&"
import script from "./BgMusic.vue?vue&type=script&lang=js&"
export * from "./BgMusic.vue?vue&type=script&lang=js&"
import style0 from "./BgMusic.vue?vue&type=style&index=0&id=0606d6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0606d6ec",
  null
  
)

export default component.exports